export const FilterType = {
    Campaign: "Campaign",
    Family: "Family",
    GroupValue: "GroupValue",
    Language: "Language",
    Resized: "Resized",
    Size: "Size",
    Status: "Status",
    Text: "Text",
    Type: "Type"
};

// Should be in sync with packages/shared-utils/enums/masterTemplate.ts
export const TemplateType = {
    HTML5: "HTML5",
    PSD: "PSD",
    AE: "AE",
    INDESIGN: "INDESIGN"
} as const;

export const TemplateTypeLabel = {
    [TemplateType.HTML5]: "HTML5",
    [TemplateType.PSD]: "Photoshop",
    [TemplateType.AE]: "After Effects",
    [TemplateType.INDESIGN]: "InDesign"
} as const;

export const TemplatesSortBy = {
    DATE_DESC: {
        dir: "desc",
        field: "modified"
    },
    DATE_ASC: {
        dir: "asc",
        field: "modified"
    },
    WIDTH_DESC: {
        dir: "desc",
        field: "width"
    },
    WIDTH_ASC: {
        dir: "asc",
        field: "width"
    }
} as const;

export type TemplateSortByKey = keyof typeof TemplatesSortBy;
export type TemplateSortByType = (typeof TemplatesSortBy)[TemplateSortByKey];

export type TemplateFilter = {
    type: keyof typeof FilterType;
    values: string[] | string;
};

export const MasterTemplateUploadStatus = {
    UPLOADING: "UPLOADING",
    UPLOADED: "UPLOADED",
    FAILED: "FAILED"
} as const;

export const MasterTemplateEvents = {
    UpdateMasterTemplateUploadList: "updateMasterTemplateUploadList",
    RefreshMasterTemplateList: "refreshMasterTemplateList"
} as const;
